export default __webpack_public_path__ + "static/media/capacita.f6aa0468.svg";